import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import TableHead from './TableHead/TableHead';
import TableBody from './TableBody/TableBody';
import styles from './Table.module.scss';
const Table = ({ columns, tableData, className, columnEnd, columnStart, onClick }) => {
    const handleTableClick = (data) => {
        if (onClick) {
            onClick(data);
        }
    };
    return (_jsxs("div", Object.assign({ className: styles.element }, { children: [_jsx(TableHead, { columnStart: columnStart, className: className, columns: columns }), _jsx(TableBody, { onClick: handleTableClick, columnStart: columnStart, columnEnd: columnEnd, className: className, columns: columns, tableData: tableData })] })));
};
export default Table;
